import React from 'react'
import CartSection from '../components/CartSection';
import Footer from '../components/Footer'

function Cart() {
  return (
    <div>
      <CartSection />
      <Footer />
    </div>
  )
}

export default Cart;
